import { useFormikContext } from 'formik';
import { MutableRefObject, useEffect, useRef } from 'react';
import { ScrollOptions } from '../../Scroll';
import { UseScrollToOnError } from './useScrollToOnError.types';

/**
 * Scrolls to the referenced node when an error with the corresponding name exists.
 *
 * @param scrollable - {@link UseScrollToOnError scrollable} description.
 * @param name - {@link UseScrollToOnError name} description.
 */
const useScrollToOnError: UseScrollToOnError = ({
    scrollable,
    name,
}) => {
    const { submitCount, errors, isValid } = useFormikContext();
    const prevSubmitCountRef: MutableRefObject<number> = useRef<number>(submitCount);
    const firstErrorKey: string = Object.keys(errors)[0];

    useEffect(() => {
        if (prevSubmitCountRef.current !== submitCount && !isValid) {
            if (scrollable.current && firstErrorKey === name) {
                scrollable.current.scrollIntoView(ScrollOptions);
                scrollable.current.focus();
            }

            prevSubmitCountRef.current = submitCount;
        }
    }, [scrollable, firstErrorKey, name, submitCount, isValid]);
};

export default useScrollToOnError;